import * as React from 'react';
import { findAccountByCriteria } from 'ts/services/find-account/FindAccountService';
import { DOB, LAST_NAME, POSTCODE, USERNAME } from '../../../../constants/UrlParams';
import { ROUTES } from '../../../../Routes';
import { AccountNumberPage } from '../../pages/account-number/AccountNumberPage';
import { Content } from '../../pages/account-number/Interfaces';
import { ERROR_CODES } from '../../pages/error/ErrorCodes';
import { navigateToErrorPageFromForgotEmail } from '../../pages/error/ErrorNavigation';

interface ForgotUsernameAccountNumberPageProps {
  history: any;
  location: any;
}

const content: Content = {
  analytics: {
    navigation: {
      friendlyUri: 'originenergy:my-account:auth:forgot-email-verify-account',
    },
    errorForm: {
      formName: 'my-account:forgot-email',
      errorMessage: 'forgot-email:invalid-account-number',
      errorCode: 'invalid-account-number',
    },
    interaction: {
      click: {
        appName: 'my-account:forgot-email',
      },
    },
  },
  copy: {
    headingText: 'We need to double check',
    infoText:
      "There's a couple of accounts that match those details. Please enter your account number so we can clear this up.",
    alertBoxText:
      "Hmm, we can't find an account linked to those details. Please check and try again, or [contact us](LIVECHAT).",
  },
};

const nextAction = (history: any) => (email: string) => {
  history.push({
    pathname: ROUTES.FORGOT_USERNAME_ACCOUNT_FOUND,
    search: `?${USERNAME}=${email}`,
  });
};

const errorPageAction = (history: any) => () => {
  navigateToErrorPageFromForgotEmail(ERROR_CODES.FORGOT_EMAIL_ACCOUNT_SEARCH, history);
};

const findAccountAction = (
  lastName: string,
  dob: string,
  postcode: string,
  accountNumber: string,
) => {
  return findAccountByCriteria(lastName, dob, postcode, accountNumber);
};

const ForgotUsernameAccountNumberPage: React.FC<ForgotUsernameAccountNumberPageProps> = ({
  history,
  location,
}) => {
  const searchParams = new URLSearchParams(location.search);
  return (
    <AccountNumberPage
      findAccountAction={findAccountAction}
      content={content}
      history={history}
      nextAction={nextAction(history)}
      errorPageAction={errorPageAction(history)}
      lastName={searchParams.get(LAST_NAME)}
      dob={searchParams.get(DOB)}
      postcode={searchParams.get(POSTCODE)}
    />
  );
};

export { ForgotUsernameAccountNumberPage };
